import { useMutation } from '@tanstack/react-query';
import { postProductOrder } from '../api/client';

export const usePlaceOrder = () => {
    const { mutateAsync: placeOrder } = useMutation({
        mutationKey: ['placeOrder'],
        mutationFn: ({ scId, otpReferenceId }: { scId: string, otpReferenceId: string }) => {
            return postProductOrder({ scId, otpReferenceId });
        },
    });
    return placeOrder;
}